import 'reflect-metadata';
import { Expose } from 'class-transformer';
import { IsNumber } from 'class-validator';
import { LengthValue } from './LengthValue'; // Adjust the import path as needed
import { ELengthValueType } from './ELengthValueType'; // Adjust the import path as needed

export class LengthValueMeter extends LengthValue {
    
    @Expose()
    @IsNumber()
    private _meter: number;

    constructor(value: number) {
        super(value);
        this._meter = value;
    }

    @Expose()
    get millimeter(): number {
        return Math.round(this._meter * 1000);
    }

    @Expose()
    get centimeter(): number {
        return this._meter * 100;
    }

    @Expose()
    get meter(): number {
        return this._meter;
    }

    @Expose()
    get type(): ELengthValueType {
        return ELengthValueType.Meter;
    }

    static multiply(a: LengthValueMeter, b: number): LengthValueMeter {
        return new LengthValueMeter(a.meter * b);
    }

    static add(a: LengthValueMeter, b: LengthValueMeter): LengthValueMeter {
        return new LengthValueMeter(a.meter + b.meter);
    }

    static subtract(a: LengthValueMeter, b: LengthValueMeter): LengthValueMeter {
        return new LengthValueMeter(a.meter - b.meter);
    }
}
